<div *ngIf="rightsMap.use_nextcloud_provider !== false; else noAccess" class="body">

    <div class="super-filter-container">
        <mat-form-field class="super-filter">
            <mat-label>Datensätze filtern</mat-label>
            <input matInput placeholder="z.B. nach GUID, Datum oder Nutzername"
                (keyup)="applyFilter($event.target.value)" />
        </mat-form-field>
        <mat-icon class="refresh-button" (click)="refresh()">refresh</mat-icon>
    </div>

    <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" class="log-table">
            <ng-container matColumnDef="options">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <mat-icon class="remover" matTooltip="Einträg löschen">delete_forever</mat-icon>
                    <mat-icon class="solver" matTooltip="Problem lösen">build</mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="auditid">
                <th mat-header-cell *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let row">{{row.auditid}}</td>
            </ng-container>

            <ng-container matColumnDef="auditdate">
                <th mat-header-cell *matHeaderCellDef>Datum</th>
                <td mat-cell *matCellDef="let row">{{row.auditdate | date:'dd.MM.yyyy HH:mm:ss'}}</td>
            </ng-container>

            <ng-container matColumnDef="diffdate">
                <th mat-header-cell *matHeaderCellDef>Diff.-Date</th>
                <td mat-cell *matCellDef="let row">{{diffdate(row)}}</td>
            </ng-container>

            <ng-container matColumnDef="audituser">
                <th mat-header-cell *matHeaderCellDef>Nutzer-ID</th>
                <td mat-cell *matCellDef="let row">{{row.audituser}}</td>
            </ng-container>

            <ng-container matColumnDef="auditcomponent">
                <th mat-header-cell *matHeaderCellDef>Komponente</th>
                <td mat-cell *matCellDef="let row">{{row.auditcomponent}}</td>
            </ng-container>

            <ng-container matColumnDef="auditerror">
                <th mat-header-cell *matHeaderCellDef>Probleme</th>
                <td mat-cell *matCellDef="let row">{{row.auditerror}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [length]=length [pageSize]="pageSize" (page)="updatePageIndex($event)"></mat-paginator>

</div>

<ng-template #noAccess>
    <app-deny-access source="'access-denied-log.component'" [requirements]="requirements"></app-deny-access>
</ng-template>